/**
 * GSAP Animation System
 * Reusable scroll-triggered animations for Shopify theme blocks.
 * Reads data-animation-* attributes and applies GSAP animations.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getAnimationProps(type) {
    switch (type) {
      case 'fade-in':
        return { from: { opacity: 0 }, to: { opacity: 1 } };
      case 'fade-in-up':
        return { from: { opacity: 0, y: 10 }, to: { opacity: 1, y: 0 } };
      case 'fade-in-down':
        return { from: { opacity: 0, y: -10 }, to: { opacity: 1, y: 0 } };
      case 'fade-in-left':
        return { from: { opacity: 0, x: -10 }, to: { opacity: 1, x: 0 } };
      case 'fade-in-right':
        return { from: { opacity: 0, x: 10 }, to: { opacity: 1, x: 0 } };
      case 'zoom-in':
        return { from: { opacity: 0, scale: 0.8 }, to: { opacity: 1, scale: 1 } };
      case 'zoom-out':
        return { from: { opacity: 0, scale: 1.2 }, to: { opacity: 1, scale: 1 } };
      case 'slide-up':
        return { from: { y: 100 }, to: { y: 0 } };
      case 'slide-down':
        return { from: { y: -100 }, to: { y: 0 } };
      case 'slide-left':
        return { from: { x: -100 }, to: { x: 0 } };
      case 'slide-right':
        return { from: { x: 100 }, to: { x: 0 } };
      case 'flip-up':
        return { from: { opacity: 0, rotationX: 90 }, to: { opacity: 1, rotationX: 0 } };
      case 'flip-down':
        return { from: { opacity: 0, rotationX: -90 }, to: { opacity: 1, rotationX: 0 } };
      case 'rotate-in':
        return { from: { opacity: 0, rotation: -180 }, to: { opacity: 1, rotation: 0 } };
      case 'bounce-in':
        return { from: { opacity: 0, scale: 0.3 }, to: { opacity: 1, scale: 1, ease: 'elastic.out(1, 0.5)' } };
      default:
        return null;
    }
  }

  function getEasing(easing) {
    switch (easing) {
      case 'ease':
        return 'power1.out';
      case 'ease-in':
        return 'power2.in';
      case 'ease-out':
        return 'power2.out';
      case 'ease-in-out':
        return 'power2.inOut';
      case 'elastic':
        return 'elastic.out(1, 0.5)';
      case 'bounce':
        return 'bounce.out';
      case 'back':
        return 'back.out(1.7)';
      default:
        return 'power2.out';
    }
  }

  function forceVisibleFallback() {
    /* GSAP failed to load — strip any animation-driven invisibility so content shows. */
    document.querySelectorAll('[data-animation-type]').forEach(function (el) {
      if (el.dataset.animationInitialized === 'true') return;
      el.dataset.animationInitialized = 'true';
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  function initAnimations() {
    if (prefersReducedMotion()) { forceVisibleFallback(); return; }

    window.gsapWait(function (gsap, ScrollTrigger) {
      if (!gsap) { forceVisibleFallback(); return; }

      gsap.registerPlugin(ScrollTrigger);

      var elements = document.querySelectorAll('[data-animation-type]');

      elements.forEach(function (el) {
        var type = el.dataset.animationType;
        if (!type || type === 'none') return;

        if (el.dataset.animationInitialized === 'true') return;
        el.dataset.animationInitialized = 'true';

        var duration = parseFloat(el.dataset.animationDuration) || 0.8;
        var delay = parseFloat(el.dataset.animationDelay) || 0;
        var easing = el.dataset.animationEasing || 'ease-out';
        var stagger = parseFloat(el.dataset.animationStagger) || 0;
        var animOnce = el.dataset.animationOnce !== 'false';

        var props = getAnimationProps(type);
        if (!props) return;

        gsap.set(el, props.from);

        var toProps = Object.assign({}, props.to, {
          duration: duration,
          delay: delay,
          ease: props.to.ease || getEasing(easing),
          stagger: stagger,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: animOnce ? 'play none none none' : 'play none none reverse',
          },
        });

        gsap.to(el, toProps);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAnimations, 100);
  });

  document.addEventListener('shopify:block:select', function () {
    setTimeout(initAnimations, 100);
  });

  window.initGsapAnimations = initAnimations;
})();
